export default __webpack_public_path__ + "static/Industry_Experts_Badge-bf8e83ef62d0d8b5ee4a95e5ec422d58.svg";